import { render, staticRenderFns } from "./DocumentTab.vue?vue&type=template&id=2e21b65d&scoped=true"
import script from "./DocumentTab.vue?vue&type=script&lang=js"
export * from "./DocumentTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentTab.vue?vue&type=style&index=0&id=2e21b65d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21b65d",
  null
  
)

export default component.exports